import React from 'react';

import '../../scss/components/_payment.scss';


const Payment = () => {

	return (
		<div className="Payment" id="Payment">
			<siv className="Payment-content">
				<h3>Resume</h3>
				<h4>aca vendrian los resumenes</h4>
				<h1>EN REPARACION</h1>
				<br />
				<div className="Payment-button">Metodo de pago</div>
				<div className="Payment-button">Metodo de pago</div>
				<div className="Payment-button">Metodo de pago</div>
				<div className="Payment-button">Metodo de pago</div>
			</siv>
		</div>
	);
};

export default Payment;
